<mat-form-field [appearance]="appearance" [class]="inputClasses">
  <mat-icon *ngIf="toolTip" matPrefix [matTooltip]="toolTip" matTooltipClass="example-tooltip-conf"
    [matTooltipPosition]="tooltipPosition">
    help
  </mat-icon>

  <input matInput mask="00000-000" type="text" placeholder="00000-000" [formControl]="cepForm" #input (blur)="onBlur()"
    (keyup)="keyPressSubmit($event)" />

  <mat-label>{{ label }}</mat-label>

  <button matIconSuffix mat-icon-button type="button" aria-label="Buscar endereço" class="bg-light mr-1"
    (click)="getEndereco(cepForm?.value)" [disabled]="disabled || isProgress" [matTooltip]="buttonTooltip"
    matTooltipClass="example-tooltip-conf" matTooltipPosition="above">
    <mat-icon>{{ icon }}</mat-icon>
  </button>

  <mat-error *ngIf="cepForm?.hasError('required') && isFocused(input)">
    Campo Obrigatório *
  </mat-error>

  <mat-error *ngIf="!cepForm?.hasError('required') && cepForm?.hasError('invalidCEP')">
    CEP inválido
  </mat-error>

  <app-input-loading [isLoading]="isProgress || isLoading"></app-input-loading>
</mat-form-field>
